var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center thank-you-message"},[_vm._v(_vm._s(this.$t("survey_save_success")))])
}
var staticRenderFns = []

export { render, staticRenderFns }